import React from "react";

function ManagerDashboard() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-xl w-full text-center">
        <h1 className="text-3xl font-bold mb-4">Manager Dashboard</h1>
        <p className="text-gray-700">Welcome! You are logged in as manager.</p>
      </div>
    </div>
  );
}

export default ManagerDashboard;
